import { formatImageUrl, isDefined, slugify } from '@/helpers';
import { IngredientMetadata, MonoMenuEntree, MonoMenuItem, Recipe } from '@/models';
import { Routes } from '@/router';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgIngredientPanel',
})
export default class CmgIngredientPanel extends Vue {  

  get ingredient(): IngredientMetadata | null {
    return this.$appStore.state.ui.ingredientsPage.selectedIngredient;
  }

  get ingredients(): IngredientMetadata[] {
    return this.$appStore.state.ui.ingredientsPage.visibleIngredients;
  }

  get menuItems(): (MonoMenuItem | MonoMenuEntree)[] {
    return this.ingredient?.menuItems.map(m => this.$services.monoMenu.getMonoMenuEntree(m, true) ?? this.$services.monoMenu.getMonoMenuItem(m, true, 'CMG-1')).filter(isDefined) || [];
  }

  async mounted() {
    await this.$services.monoMenu.awaitCacheItemsAndBuildMenu();
  }

  onCloseIngredient() {
    this.$services.ui.setIngredientPanelVisibility(false);
    this.$services.ui.setIngredient(null);
    this.$router.push({ name: Routes.IngredientsLandingPage, params: { ingredientNavigation: 'true' } });
  }

  onClickPreviousIngredient(): void {
    const currentIngredientIndex = this.$appStore.state.ui.ingredientsPage.visibleIngredients.findIndex(i => i.title == this.ingredient?.title);
    const previousIngredient = this.ingredients[(currentIngredientIndex + (this.ingredients.length - 1)) % this.ingredients.length];
    const title = slugify(previousIngredient.metaTitle);

    this.$services.ui.setIngredient(previousIngredient);
    this.$router.push({ name: Routes.IngredientsLandingPageIngredientSelect, params: { ingredientName: title, ingredientNavigation: 'true' } });
  }

  onClickNextIngredient(): void {
    const currentIngredientIndex = this.ingredients.findIndex(i => i.title == this.ingredient?.title);
    const nextIngredient = this.ingredients[(currentIngredientIndex + 1) % this.ingredients.length];
    const title = slugify(nextIngredient.metaTitle);

    this.$services.ui.setIngredient(nextIngredient);
    this.$router.push({ name: Routes.IngredientsLandingPageIngredientSelect, params: { ingredientName: title, ingredientNavigation: 'true' } });
  }
  
  getBackgroundImageUrl(relativeUrl: string): string {
    return formatImageUrl(relativeUrl);
  }
}
